import { createSelector } from '@reduxjs/toolkit'
import EVENT_TYPES from '../const/eventType'
import { getDelayedStorageStatus } from '../MediaPlayer/mediaPlayer.selectors'

const contactSelector = state => state.media.main.contact
const storageFileSelector = state => state.media.main.storageFile
const speechSelector = state => state.media.speech
const eventsSelector = state => state.media.events
const commentsSelector = state => state.media.comments
const energySelector = state => state.media.energy

export const getIsAudioDelayed = createSelector(getDelayedStorageStatus, delayedStorage => delayedStorage.audio)

export const getAudioPanelErrorStatus = createSelector(
  contactSelector,
  storageFileSelector,
  eventsSelector,
  commentsSelector,
  energySelector,
  getIsAudioDelayed,
  (contact, storageFile, events, comments, energy, isAudioDelayed) =>
    isAudioDelayed || contact.error || storageFile.error || events.error || comments.error || energy.error,
)

// only selectors that audio panel ENERGY needs
export const getAudioPanelEnergyErrorStatus = createSelector(
  energySelector,
  energy =>
    energy.error,
)

// Ensure loading ends if audio is delayed or there is an error
export const getAudioPanelLoadingStatus = createSelector(
  contactSelector,
  storageFileSelector,
  speechSelector,
  eventsSelector,
  commentsSelector,
  energySelector,
  getAudioPanelErrorStatus,
  (contact, storageFile, speech, events, comments, energy, error) =>
    (contact.loading ||
      storageFile.loading ||
      speech.loading ||
      events.loading ||
      comments.loading ||
      energy.loading) &&
    !error,
)

export const getEventsData = createSelector(eventsSelector, events => events.data)

export const getEnergyData = createSelector(energySelector, energy => energy.data)

export const mapCommentsData = createSelector(commentsSelector, comments =>
  comments.data.map(c => ({ ...c, eventType: EVENT_TYPES.COMMENT })),
)

const getSpeechHitsData = createSelector(speechSelector, speech =>
  speech.data && speech.data.hits ? speech.data.hits : [],
)

export const mapSpeechHitsData = createSelector(getSpeechHitsData, hits =>
  hits.map(h => ({ ...h, eventType: EVENT_TYPES.TRANSCRIPTION_HIT })),
)
